// extracted by mini-css-extract-plugin
module.exports = {"header":"SidebarHead_header__3F8J9","org":"SidebarHead_org__1a2n9","avatar":"SidebarHead_avatar__3PAxj","name":"SidebarHead_name__1OWT0","user":"SidebarHead_user__muhAM"};